export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sport-home-custom-banner.vue?vue&type=template&id=47d96ea2"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-home-custom-banner.vue?vue&type=template&id=47d96ea2
// module id = TA99
// module chunks = 0